<script>
import Layout from "@/router/layouts/main";
import { mapState } from "vuex";

export default {
  locales: {
    pt: {
    },
    es: {
    }
  },
  components: {
    Layout,
  },
  computed: {
    ...mapState({
      account: state => state.account
    }),
  },
  data() {
    return {
    };
  },
  methods: {
  },
  mounted() {
  }
};
</script>

<template>
  <Layout>
    <div class="page-title-box d-md-flex justify-content-between mb-3">
      <div>
        <h3>Seguros</h3>
        <p></p>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-6">
        <router-link class="text-dark" tag="a" to="/seguros/assistencia-funeral">
          <div class="card card-icon">
            <div class="card-body d-flex align-items-center">
              <div class="icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(255, 255, 255, 1);">
                  <path
                    d="M20.995 6.903a.997.997 0 0 0-.547-.797l-7.973-4a.997.997 0 0 0-.895-.002l-8.027 4c-.297.15-.502.437-.544.767-.013.097-1.145 9.741 8.541 15.008a.995.995 0 0 0 .969-.009c9.307-5.259 8.514-14.573 8.476-14.967zm-8.977 12.944c-6.86-4.01-7.14-10.352-7.063-12.205l7.071-3.523 6.998 3.511c.005 1.87-.481 8.243-7.006 12.217z">
                  </path>
                </svg>
              </div>
              <div class="ml-3">
                <h5 class="mb-1">Assistência Funeral</h5>
                <p class="m-0"></p>
              </div>
            </div>
          </div>
        </router-link>
      </div>
      <div class="col-lg-6">
        <router-link class="text-dark" tag="a" to="/seguros/seguro-de-vida">
          <div class="card card-icon">
            <div class="card-body d-flex align-items-center">
              <div class="icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(255, 255, 255, 1);">
                  <path
                    d="M20.995 6.903a.997.997 0 0 0-.547-.797l-7.973-4a.997.997 0 0 0-.895-.002l-8.027 4c-.297.15-.502.437-.544.767-.013.097-1.145 9.741 8.541 15.008a.995.995 0 0 0 .969-.009c9.307-5.259 8.514-14.573 8.476-14.967zm-8.977 12.944c-6.86-4.01-7.14-10.352-7.063-12.205l7.071-3.523 6.998 3.511c.005 1.87-.481 8.243-7.006 12.217z">
                  </path>
                </svg>
              </div>
              <div class="ml-3">
                <h5 class="mb-1">Seguro de Vida</h5>
                <p class="m-0"></p>
              </div>
            </div>
          </div>
        </router-link>
      </div>
      <div class="col-lg-6">
        <router-link class="text-dark" tag="a" to="/seguros/checkup-anual">
          <div class="card card-icon">
            <div class="card-body d-flex align-items-center">
              <div class="icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(255, 255, 255, 1);">
                  <path
                    d="M20.995 6.903a.997.997 0 0 0-.547-.797l-7.973-4a.997.997 0 0 0-.895-.002l-8.027 4c-.297.15-.502.437-.544.767-.013.097-1.145 9.741 8.541 15.008a.995.995 0 0 0 .969-.009c9.307-5.259 8.514-14.573 8.476-14.967zm-8.977 12.944c-6.86-4.01-7.14-10.352-7.063-12.205l7.071-3.523 6.998 3.511c.005 1.87-.481 8.243-7.006 12.217z">
                  </path>
                </svg>
              </div>
              <div class="ml-3">
                <h5 class="mb-1">Checkup Anual</h5>
                <p class="m-0"></p>
              </div>
            </div>
          </div>
        </router-link>
      </div>
      <div class="col-lg-6">
        <router-link class="text-dark" tag="a" to="/seguros/assistencia-residencial">
          <div class="card card-icon">
            <div class="card-body d-flex align-items-center">
              <div class="icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(255, 255, 255, 1);">
                  <path
                    d="M20.995 6.903a.997.997 0 0 0-.547-.797l-7.973-4a.997.997 0 0 0-.895-.002l-8.027 4c-.297.15-.502.437-.544.767-.013.097-1.145 9.741 8.541 15.008a.995.995 0 0 0 .969-.009c9.307-5.259 8.514-14.573 8.476-14.967zm-8.977 12.944c-6.86-4.01-7.14-10.352-7.063-12.205l7.071-3.523 6.998 3.511c.005 1.87-.481 8.243-7.006 12.217z">
                  </path>
                </svg>
              </div>
              <div class="ml-3">
                <h5 class="mb-1">Assistência Residêncial</h5>
                <p class="m-0"></p>
              </div>
            </div>
          </div>
        </router-link>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.disabled * {
  filter: grayscale(1);
  opacity: .85;
}
</style>